import React, { Component, Fragment } from "react";

import Button from "@material-ui/core/Button";
import { withRouter, Link } from "react-router-dom";
import { inject, observer } from "mobx-react";
import CustomEmbed from "./CustomEmbedGigWidget";
import CodeBlock from "../common/CodeBlock";
import { EmbedType } from "../../types/enum";
const BASE_URL = process.env.REACT_APP_BASE_URL;

@withRouter
@inject("templateStore", "profileStore", "embedGigStore")
@observer
class EmbedGigWidget extends Component {
    state = {
        open: false,
        showCustomise: false
    };

    handleClickOpen = () => this.setState({ open: true });

    handleClose = () => this.setState({ open: false });

    generateParameters = (...par) => {
        let args = par.map(ar => {
            return typeof ar === "string" ? ar.replace("#", "") : ar;
        });
        var params = 
            "?tableBgColor=" + 
            args[2] + 
            "&tableFtColor=" + 
            args[3] + 
            "&hideToolbar=" + 
            args[6];
        if(args[9] === EmbedType.Grid.ordinal){
            var params = 
            "?tableBgColor=" + 
            args[2] + 
            "&tableFtColor=" + 
            args[3]
        }
        if(args[10]){
            params = params +  "&tableWidgetBgColor=" + args[10]
            params = params +  "&enabledTransparent=" + args[11]
        }
        return params;
    };

    componentDidMount() {
        const { profile } = this.props.profileStore;
        if(profile){
            this.props.embedGigStore.loadEmbedCode( profile.id );
        }else if(this.props.match.params.id){
            this.props.embedGigStore.loadEmbedCode(this.props.match.params.id);
        }
        else{
            this.props.embedGigStore.loadEmbedCode(0);
        }
        
    }
    getEmbedText(embedType){
        switch (embedType) {
            case EmbedType.Large.ordinal:
                return "embed/";
            case EmbedType.Table.ordinal:
                return "embedtext/";
            case EmbedType.Grid.ordinal:
                return "embedgrid/"
            default:
                return "embedgrid/";
        }
    }

    render() {
        const { profile } = this.props.profileStore;
        const { headerBgColor, headerFtColor, tableBgColor, tableFtColor, dateBgColor, dateFtColor, hideToolbar, hideOrderUber, hideShareButton,embedType,tableWidgetBgColor,enabledTransparent } = this.props.embedGigStore;
        const parameters = this.generateParameters(headerBgColor, headerFtColor, tableBgColor, tableFtColor, dateBgColor, dateFtColor, hideToolbar, hideOrderUber, hideShareButton,embedType, tableWidgetBgColor,enabledTransparent);
        const embedText = this.getEmbedText(embedType)
        const scriptLink =  `<script src="${BASE_URL}js/iframeResizer.min.js"></script>`
        const link = embedType === 2? `${scriptLink}\n<iframe allowTransparency="true"\n    onload="iFrameResize({},this)" width="100%" height="800"\n    src="${BASE_URL + embedText + (profile ? profile.id : 0) + parameters}"\n    frameborder="0"></iframe>` : `<iframe width="100%" height="800"\n    src="${BASE_URL + embedText + (profile ? profile.id : 0) + parameters}"\n    frameborder="0"></iframe>`;
        return (
            <Fragment>
                <CodeBlock 
                    code={link} 
                    showCopy={true}
                    showCustomise={false}
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '8px' }}>
                    <CustomEmbed profile={profile} profileId={ (profile ? profile.id : 0) } />
                </div>
            </Fragment>
        );
    }
}

export default EmbedGigWidget;
